export default function React_Radio() {
  return (
    <div>
      <h1>React_Radio Component</h1>
      <p>This is the React_Radio tutorial page.</p>
    </div>
  );
}
